export const lastNameInitial = (name: string) => {
  const words = name.trim().split(` `)
  if (words.length <= 1) {
    return ``
  }
  return words[words.length - 1][0] ?? ``
}
